export default function loaderReducer(_, action) {
    const { isLoading } = action;
    return {
        isLoading: isLoading || false,
    };
}
